import React, { useEffect, useState } from "react";
import "./awb_slip.css";
import { useSearchParams } from "react-router-dom";
import UseToast from "utils/AfToast";
import { AxiosResponse } from "axios";
import { GetCommanWay, ListCommanWay } from "API/commonApi";
import { UseMutateFunction, useMutation, useQuery } from "@tanstack/react-query";
import Barcode from "react-barcode";
import moment from "moment";
import QRCode from "react-qr-code";

const AwbSlip = () => {
  const BASE_URL = process.env.REACT_APP_BACKEND_URL;
  const [awbNo, setAwbNo] = useState("");
  const [awbTrackingData, setAwbTrackingData] = useState<any>({
    tracking_data: [],
    bookingDate: "",
    awbData: {},
    bookingData: {},
  });

  const [searchParams, setSearchParams] = useSearchParams();
  const [deliveryDoneInfo, setDeliveryDoneInfo] = useState<any>({});
  const [productList, setProductList] = useState<any>([]);
  const [cityCodes, setCityCodes] = useState<any>("");
  const [pickupInfo, setPickupInfo] = useState<any>({});
  const [freightRate, setFreightRate] = useState<any>(0);
  const [dimensionList, setDimensionList] = useState<any>([]);

  const {} = useQuery(["admin_product_list"], () => ListCommanWay("/admin/product/list", {}, {}), {
    keepPreviousData: true,
    onSuccess(data) {
      setProductList(data.status == "SUCCESS" ? data.data.data : []);
    },
    onError: (data) => {},
  });

  const { mutate: cityCodesMutate }: any = useMutation((names) => ListCommanWay("/admin/city/list", { city_name: names }, {}), {
    onSuccess: (data: any) => {
      if (data.status == "SUCCESS") {
        let obj = {};
        try {
          obj[data.data.data[0].city_name] = data.data.data[0].cityCode;
          obj[data.data.data[1].city_name] = data.data.data[1].cityCode;
          setCityCodes(obj);
        } catch (ignored) {
          setCityCodes(obj);
        }
      }
    },
    onError: (data: any) => {},
  });

  const { mutate: pickupMutate }: any = useMutation(
    (code) =>
      ListCommanWay(
        "/admin/pickup/list",
        { pickup_code: code },
        {
          include: ["_assgined_to_agent_name"],
        }
      ),
    {
      onSuccess: (data: any) => {
        if (data.status == "SUCCESS") {
          setPickupInfo(data.data.data.length ? data.data.data[0] : {});
        }
      },
      onError: (data: any) => {},
    }
  );

  const {
    mutate,
    isLoading: isloading,
  }: {
    mutate: UseMutateFunction<AxiosResponse<any, any>, unknown, any, unknown>;
    isLoading: any;
  } = useMutation((awb_no) => GetCommanWay("/admin/proof_of_delivery/track/" + awb_no, {}, {}), {
    onSuccess: (data: any) => {
      console.log(data, data.status == "SUCCESS");
      if (data.status == "SUCCESS") {
        setAwbTrackingData(data.data);
        setDeliveryDoneInfo({});
        if (data.data.tracking_data) {
          try {
            data.data.tracking_data.forEach((t) => {
              if (t.message_code == "Shipment Delivered" || t.message_code == "0 - Shipment Delivered") {
                setDeliveryDoneInfo(t);
              }
            });
          } catch (e) {}
        }
        try {
          setFreightRate(
            (
              (Number(data.data?.awbData?.base_value) || 0) -
              (Number(data.data?.awbData?.holidayRate) || 0) -
              (Number(data.data?.awbData?.pickupRate) || 0) -
              (Number(data.data?.awbData?.deliveryRate) || 0) -
              (Number(data.data?.awbData?.odaRate) || 0) -
              (Number(data.data?.awbData?.fuelRate) || 0) -
              (Number(data.data?.awbData?.chcRate) || 0) -
              (Number(data.data?.awbData?.fovRate) || 0) -
              (Number(data.data?.awbData?.insuranceRate) || 0) -
              (Number(data.data?.awbData?.dgRate) || 0) -
              (Number(data.data?.awbData?.pkgRate) || 0) -
              (Number(data.data?.awbData?.diceRate) || 0) -
              (Number(data.data?.awbData?.toPayRate) || 0) -
              (Number(data.data?.awbData?.demurrageRate) || 0) -
              (Number(data.data?.awbData?.abRate) || 0) -
              (Number(data.data?.awbData?.otherRate) || 0)
            ).toFixed(2)
          );
        } catch (cc) {
          console.log(cc);
        }
        data.data?.bookingData?.pickup_code && pickupMutate(data.data?.bookingData?.pickup_code);
        cityCodesMutate([data.data?.awbData?.destination || "", data.data?.bookingData?.shipper_city || ""]);

        let innerItemsJson = [];
        try {
          if (!data.data?.awbData?.innerItemsJson || data.data?.awbData?.innerItemsJson == "[]") {
            innerItemsJson = [{ l: data.data?.awbData?.l || "0", b: data.data?.awbData?.b || "0", h: data.data?.awbData?.h || "0" }];
          } else {
            innerItemsJson = JSON.parse(data.data?.awbData?.innerItemsJson);
          }
        } catch (c) {}

        const dimensionMap = {};
        // Loop through the array to group dimensions and count occurrences
        innerItemsJson.forEach((item) => {
          const key = `${item.l}x${item.b}x${item.h}`; // Create key from l, b, h
          if (dimensionMap[key]) {
            dimensionMap[key] += 1; // Increment the count if key exists
          } else {
            dimensionMap[key] = 1; // Initialize the count if key does not exist
          }
        });
        const result = Object.entries(dimensionMap).map(([dimensions, count]) => {
          return `${count} x (${dimensions})`;
        });
        setDimensionList(result);
      } else {
        UseToast(data.message, "error");
      }
    },
    onError: (data: any) => {
      typeof data === "string" ? UseToast(data, "error") : UseToast(data.message, "error");
    },
  });

  useEffect(() => {
    if (searchParams.get("awb")) {
      setAwbNo(searchParams.get("awb"));
      setAwbTrackingData({
        tracking_data: [],
        bookingDate: "",
        awbData: {},
        bookingData: {},
      });
      mutate(searchParams.get("awb"));
    }
  }, [searchParams]);

  const getChargeableWeight = (weight, product_code, ll, bb, hh) => {
    ll = Number(ll);
    bb = Number(bb);
    hh = Number(hh);
    let dWeight = (ll * bb * hh) / (product_code == "X" ? 2700 : 5000);
    return Math.max(Number(weight), dWeight);
  };

  const getChargeItem = (val, label) => {
    let _val = Number(val);
    return _val ? (
      <tr style={{ borderBottom: "1px solid black" }}>
        <td style={{ padding: "0.8mm" }}>{label} </td>
        <td style={{ textAlign: "right", paddingRight: "1.5mm" }}>{_val.toFixed(2)}</td>
      </tr>
    ) : (
      ""
    );
  };
  return (
    <>
      <div
        style={{
          width: "210mm",
          height: "153mm",
          margin: "0 auto",
          position: "relative",
          fontFamily: "Helvetica, sans-serif",
          fontStretch: "condensed",
          lineHeight: "normal",
        }}
      >
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "157mm",
            backgroundImage: 'url("https://airfield.express/logo3.png")',
            backgroundSize: "35mm",
            opacity: "0.05",
            pointerEvents: "none",
          }}
        ></div>
        <div className="flex border-black" style={{ height: "100%", justifyContent: "space-between" }}>
          <div
            style={{
              flex: 1,
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                borderBottom: "1px solid black",
              }}
            >
              <div style={{ display: "flex", alignItems: "center", margin: "0.3mm" }}>
                <img
                  src="data:image/png;base64,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"
                  style={{ height: "12mm" }}
                />
                <img src="https://airfield.express/logo3.png" style={{ height: "12.2mm" }} />
              </div>
              <div
                style={{
                  backgroundColor: "#034da2",
                  color: "#fff",
                  height: "12.2mm",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginRight: "0.25mm",
                  padding: "0 6mm",
                }}
              >
                <p>
                  <b>
                    {productList
                      .map((p) => {
                        return p.product_code == awbTrackingData.awbData.prefix ? p.product_name : "";
                      })
                      .join("")}
                  </b>
                </p>
              </div>
            </div>
            <div className="flex" style={{}}>
              <div style={{ flex: 1 }}>
                <div className="flex" style={{ height: "100%", width: "100%" }}>
                  <div
                    style={{
                      backgroundColor: "#034da2",
                      padding: "2mm 0.2mm",
                      color: "#fff",
                      display: "inline-block",
                      writingMode: "vertical-rl",
                      transform: "rotate(180deg)",
                      fontSize: "3.2mm",
                      letterSpacing: "0.25mm",
                    }}
                  >
                    <b>SHIPPER</b>
                  </div>
                  <div style={{ margin: "1mm 2mm", flex: 1 }}>
                    <div style={{ display: "flex" }}>
                      <p>Client Code:</p>
                      <p style={{ flex: 1, borderBottom: "1px solid slategray" }}>{awbTrackingData?.bookingData?.customer_code || "N/A"}</p>
                    </div>
                    <div style={{ display: "flex" }}>
                      <p>Company:</p>
                      <p style={{ flex: 1, borderBottom: "1px solid slategray" }}>{awbTrackingData?.bookingData?.shipper_company}</p>
                    </div>
                    <div style={{ display: "flex" }}>
                      <p>Sender: </p>
                      <p style={{ flex: 1, borderBottom: "1px solid slategray" }}>{awbTrackingData?.bookingData?.shipper_sh}</p>
                    </div>
                    <div style={{ display: "flex" }}>
                      <p>Address:</p>
                      <p style={{ flex: 1, borderBottom: "1px solid slategray" }}>
                        <small>{awbTrackingData?.bookingData?.shipper_address}</small>
                      </p>
                    </div>
                    <div style={{ display: "flex" }}>
                      <p>City:</p>
                      <p style={{ flex: 2, borderBottom: "1px solid slategray" }}>{awbTrackingData?.bookingData?.shipper_city}</p>
                      <p>Pin:</p>
                      <p style={{ flex: 1, borderBottom: "1px solid slategray" }}>{awbTrackingData?.bookingData?.shipper_pincode}</p>
                    </div>
                    <div style={{ display: "flex" }}>
                      <p>Eway Bill No.:</p>
                      <p style={{ flex: 1, borderBottom: "1px solid slategray" }}>{awbTrackingData?.bookingData?.ewayBillNo}</p>
                    </div>
                    <div style={{ display: "flex" }}>
                      <p>GST:</p>
                      <p style={{ flex: 1, borderBottom: "1px solid slategray" }}>{awbTrackingData?.bookingData?.shipper_gst_no}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div style={{ flex: 1, borderLeft: "1px solid black", borderBottom: "1px solid black", borderTop: "1px solid black" }}>
                <div className="flex" style={{ height: "100%" }}>
                  <div
                    style={{
                      backgroundColor: "#034da2",
                      padding: "2mm 0.2mm",
                      color: "#fff",
                      display: "inline-block",
                      writingMode: "vertical-rl",
                      transform: "rotate(180deg)",
                      fontSize: "3.2mm",
                      letterSpacing: "0.25mm",
                    }}
                  >
                    <b>CONSIGNEE</b>
                  </div>
                  <div style={{ margin: "1mm 2mm", flex: 1 }}>
                    <div style={{ display: "flex" }}>
                      <p>Attn.:</p>
                      <p style={{ flex: 1, borderBottom: "1px solid slategray" }}>{awbTrackingData?.awbData?.consignee}</p>
                    </div>
                    <div style={{ display: "flex" }}>
                      <p>Company:.</p>
                      <p style={{ flex: 1, borderBottom: "1px solid slategray" }}>{awbTrackingData?.awbData?.consignee_company}</p>
                    </div>
                    <div style={{ display: "flex" }}>
                      <p>Tel: </p>
                      <p style={{ flex: 1, borderBottom: "1px solid slategray" }}>{awbTrackingData?.awbData?.contact_no}</p>
                    </div>
                    <div style={{ display: "flex" }}>
                      <p>Address: </p>
                      <p style={{ flex: 1, borderBottom: "1px solid slategray" }}>
                        <small>{awbTrackingData?.awbData?.address}</small>
                      </p>
                    </div>
                    <div style={{ display: "flex" }}>
                      <p>City:</p>
                      <p style={{ flex: 2, borderBottom: "1px solid slategray" }}>{awbTrackingData?.awbData?.destination}</p>
                      <p>Pin:</p>
                      <p style={{ flex: 1, borderBottom: "1px solid slategray" }}>{awbTrackingData?.awbData?.pincode}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="flex" style={{ flex: 1 }}>
              <div style={{ flex: 1, minWidth: "48mm", maxWidth: "48mm" }}>
                <div style={{ fontSize: "2.6mm" }}>
                  <p
                    style={{
                      padding: "0.5mm",
                      borderBottom: "1px solid black",
                      borderTop: "1px solid black",
                    }}
                  >
                    Any Customs, Gst, Sales Tax, Duties or Taxes as may be applicable on this shipment will be paid by the Consignee at the
                    time of delivery of the shipment. AIRFIELD EXPRESS reserves the right of lien on any shipment till all its dues are paid
                    in full in respect of Freight, Customs, Gst, Taxes and other charges.
                  </p>
                  <p style={{ padding: "0.5mm", borderBottom: "1px solid black" }}>
                    "In case this consignment contains anything of value, the company recommends insurance of the same. The company's
                    liability on this shipment is limited to Rs. 2,500/- or cost of reconstruction whichever is lower."
                  </p>
                  <p style={{ padding: "0.5mm", borderBottom: "1px solid black" }}>
                    I hereby agree to the terms and conditions set forth on the reverse this (Consignor) copy of this non- negotiable way
                    bill and warrant that the information contained on this way bill is true and correct and this Consignment does not
                    contain any
                  </p>
                  <p style={{ padding: "0.5mm", borderBottom: "1px solid black" }}>
                    If Consignee fails to make any such payment(s) AIRFIELD EXPRESS shall be entitled to recover the same from the
                    Consignor. Freight charge and Service tax shall be paid by the Consignor. Any Government duty if chargeable on the
                    waybill shall be borne by the Consignor exclusively.
                  </p>
                </div>
                <div style={{ fontSize: "3mm" }}>
                  <p>Name: {awbTrackingData?.bookingData?.shipper_sh}</p>
                  <p>Shipper's Sign: _________</p>
                </div>
              </div>
              <div
                style={{
                  flex: 1,
                  display: "flex",
                  flexDirection: "column",
                  borderLeft: "1px solid black",
                }}
              >
                <div className="flex" style={{ borderBottom: "1px solid black", borderTop: "1px solid black" }}>
                  <div style={{ flex: "1.75", fontSize: "3.2mm" }}>
                    <div
                      style={{
                        backgroundColor: "#034da2",
                        color: "#fff",
                        height: "7mm",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        borderLeft: "1px solid black",
                      }}
                    >
                      <p>
                        <b>Particulars</b>
                      </p>
                    </div>
                    <p style={{ borderTop: "1px solid black", padding: "0.5mm" }}>&nbsp;{awbTrackingData?.awbData?.particulars}</p>
                  </div>
                  <div style={{ flex: 1, fontSize: "3.2mm", borderLeft: "1px solid black" }}>
                    <div
                      style={{
                        backgroundColor: "#034da2",
                        color: "#fff",
                        height: "7mm",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        textAlign: "center",
                        borderLeft: "1px solid black",
                      }}
                    >
                      <p>
                        <b>
                          Commercial
                          <br />
                          Value
                        </b>
                      </p>
                    </div>
                    <p style={{ borderTop: "1px solid black", padding: "0.5mm" }}>{awbTrackingData?.awbData?.commercialValue}</p>
                  </div>
                </div>
                <div
                  style={{
                    flex: 1,
                    alignItems: "center",
                    justifyContent: "center",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <div
                    style={{
                      position: "relative",
                      backgroundColor: "#fff",
                      width: "90%",
                      height: "95%",
                      display: "flex",
                      flexDirection: "column",
                      gap: 5,
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {/*<Barcode font="monospace" value={awbTrackingData?.awbData?.awb_no} marginTop={0.75} width={1.5} height={50} />*/}
                    <QRCode value={awbTrackingData?.awbData?.awb_no || ""} size={100} />
                    <p style={{ margin: "0", fontSize: 20, fontWeight: 500, fontFamily: "monospace", letterSpacing: 0.5 }}>
                      {awbTrackingData?.awbData?.awb_no}
                    </p>
                  </div>
                </div>
                <div style={{}}>
                  <div
                    style={{
                      fontSize: "3mm",
                      padding: "1.5mm 1mm",
                      display: "flex",
                      justifyContent: "space-between",
                      borderTop: "1px solid black",
                    }}
                  >
                    <p style={{ flex: 1 }}>
                      Act. Wt. (Kg.): <b>{awbTrackingData?.awbData?.realWeight}</b>
                    </p>
                    <p style={{ flex: 1 }}>
                      Dim. Wt. (Kg.): <b>{awbTrackingData?.awbData?.weight}</b>
                    </p>
                  </div>
                  <div
                    style={{
                      fontSize: "3mm",
                      padding: "1mm",
                      display: "flex",
                      justifyContent: "space-between",
                      borderTop: "1px solid black",
                    }}
                  >
                    <p>
                      No Of Piece.: <b>{awbTrackingData?.awbData?.innerItemsNos || "1"}</b>
                    </p>
                    <p>
                      ORIGIN: <b>{cityCodes[awbTrackingData?.bookingData?.shipper_city]}</b>
                    </p>
                    <p style={{ width: "20mm" }}>
                      DEST.: <b>{cityCodes[awbTrackingData?.awbData?.destination]}</b>
                    </p>
                  </div>
                  <p
                    style={{
                      backgroundColor: "#034da2",
                      padding: "2mm 0",
                      color: "white",
                      fontSize: "2.3mm",
                      textAlign: "center",
                    }}
                  >
                    <b>PLEASE QUOTE THE ABOVE AWB NO. FOR FUTURE CORRESPONDENCE</b>
                  </p>
                  <div className="flex">
                    <div
                      style={{
                        fontSize: "2.8mm",
                        padding: "1mm",
                        borderRight: "1px solid black",
                        flex: 1,
                        lineHeight: "5mm",
                      }}
                    >
                      <p>
                        P/U Date: <b>{awbTrackingData.bookingDate ? moment(awbTrackingData.bookingDate).format("DD/MM/YYYY") : ""}</b>
                      </p>
                      <p>
                        P/U Time: <b>{awbTrackingData.bookingDate ? moment(awbTrackingData.bookingDate).format("HH:mm") : ""}</b>
                      </p>
                      <p>Emp.#: {awbTrackingData?.bookingData?.agentData?.employeeCode}</p>
                      <p>
                        CASH/Credit:{" "}
                        <u>
                          <b>{awbTrackingData?.bookingData?.customer_code ? "CREDIT" : "CASH"}</b>
                        </u>
                      </p>
                      <p>
                        W/I or P/U:{" "}
                        <u>
                          <b>{awbTrackingData?.bookingData?.type}</b>
                        </u>
                      </p>
                    </div>
                    <div style={{ fontSize: "2.8mm", padding: "1mm", flex: "1.6" }}>
                      <p>
                        The Consigner has stated that:
                        <br />
                        {awbTrackingData?.awbData?.insuranceAmount ? "✗" : "✔"} Has not insured the Consignment
                        <br />
                        {awbTrackingData?.awbData?.insuranceAmount ? "✔" : "✗"} Has insured the Consignment
                        <br />
                        &nbsp;
                      </p>
                      <div style={{ lineHeight: "5mm" }}>
                        <p>
                          Insurance Policy No: <u>{awbTrackingData?.awbData?.insuranceNo}</u>
                        </p>
                        <p>
                          Amount: <u>{awbTrackingData?.awbData?.insuranceAmount}</u>
                        </p>
                        <p>
                          Insurance Company: <u>{awbTrackingData?.awbData?.insuranceCompany}</u>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                style={{
                  borderLeft: "1px solid black",
                  flex: 1,
                  minWidth: "40mm",
                  maxWidth: "40mm",
                }}
              >
                <div
                  style={{
                    backgroundColor: "#034da2",
                    color: "#fff",
                    height: "7.5mm",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "3.2mm",
                    borderTop: "1px solid black",
                    borderLeft: "1px solid black",
                  }}
                >
                  <p>
                    <b>Delivery</b>
                  </p>
                </div>
                <div style={{ fontSize: "3mm" }}>
                  <div style={{ padding: "1mm", lineHeight: "6mm" }}>
                    <p>
                      Del. Date:{" "}
                      {deliveryDoneInfo.updatedAt ||
                        (deliveryDoneInfo.createdAt &&
                          moment(deliveryDoneInfo.updatedAt || deliveryDoneInfo.createdAt, "DD-MM-YYYY HH:mm:ss").format("DD-MM-YYYY"))}
                    </p>
                    <p>Name: {deliveryDoneInfo._addedBy?.name}</p>
                    <p>
                      Time:{" "}
                      {deliveryDoneInfo.updatedAt ||
                        (deliveryDoneInfo.createdAt &&
                          moment(deliveryDoneInfo.updatedAt || deliveryDoneInfo.createdAt, "DD-MM-YYYY HH:mm:ss").format("HH:mm"))}
                    </p>
                  </div>
                  <p
                    style={{
                      padding: "0.5mm",
                      borderBottom: "1px solid black",
                      borderTop: "1px solid black",
                      fontSize: "2.8mm",
                    }}
                  >
                    Received above shipment in good condition. We agree to pay all charges including customes duties, taxes &amp; Gst as
                    applicable.
                  </p>
                  <div style={{ padding: "1mm" }}>
                    <p>Consignee's</p>
                    <p style={{ marginTop: "3mm" }}>
                      Name: <u>{awbTrackingData?.awbData?.consignee}</u>
                    </p>
                    <p style={{ marginTop: "6mm" }}>Signature</p>
                    <p style={{ marginTop: "6mm" }}>Relative Receiving</p>
                    <p style={{ marginTop: "6mm" }}>Company Stamp</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            style={{
              width: "50mm",
              height: "100%",
              display: "flex",
              borderLeft: "1px solid black",
            }}
          >
            <div
              style={{
                width: "46mm",
                height: "100%",
                display: "flex",
                flexDirection: "column",
                borderRight: "1px solid black",
              }}
            >
              <div
                style={{
                  backgroundColor: "rgb(231, 231, 231)",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  flex: 1,
                }}
              >
                {searchParams.get("sh") && (
                  <table
                    style={{
                      borderCollapse: "collapse",
                      width: "100%",
                      fontSize: "3.2mm",
                    }}
                  >
                    <tbody>
                      <tr style={{ borderBottom: "1px solid black", borderTop: "2px solid black" }}>
                        <td style={{ padding: "0.8mm" }}>Freight charge:</td>
                        <td style={{ textAlign: "right", paddingRight: "1.5mm" }}>{freightRate}</td>
                      </tr>
                      {getChargeItem(awbTrackingData?.awbData?.holidayRate, "Holiday charge:")}
                      {getChargeItem(awbTrackingData?.awbData?.pickupRate, "Pickup charge:")}
                      {getChargeItem(awbTrackingData?.awbData?.deliveryRate, "Delivery charge:")}
                      {getChargeItem(awbTrackingData?.awbData?.odaRate, "Oda charge:")}
                      {getChargeItem(awbTrackingData?.awbData?.fuelRate, "Fuel Surcharge:")}
                      {getChargeItem(awbTrackingData?.awbData?.chcRate, "CHC Charge:")}
                      {getChargeItem(awbTrackingData?.awbData?.fovRate, "FOV charges:")}
                      {getChargeItem(awbTrackingData?.awbData?.insuranceRate, "Insurance Charge:")}
                      {getChargeItem(awbTrackingData?.awbData?.dgRate, "D G charge:")}
                      {getChargeItem(
                        (Number(awbTrackingData?.awbData?.pkgRate) || 0) + (Number(awbTrackingData?.awbData?.diceRate) || 0),
                        "Package Charge:"
                      )}
                      {getChargeItem(awbTrackingData?.awbData?.toPayRate, "To-Pay charge:")}
                      {getChargeItem(awbTrackingData?.awbData?.demurrageRate, "Demurrage charge:")}
                      {getChargeItem(awbTrackingData?.awbData?.abRate, "Awb charge:")}
                      {getChargeItem(awbTrackingData?.awbData?.otherRate, "Other Charge:")}
                      {getChargeItem(awbTrackingData?.awbData?.tax, "GST:")}
                      <tr style={{ borderBottom: "1px solid black" }}>
                        <td style={{ padding: "0.8mm" }}>Amount: </td>
                        <td style={{ textAlign: "right", paddingRight: "1.5mm" }}>
                          <b>{(awbTrackingData?.awbData?.base_value + awbTrackingData?.awbData?.tax)?.toFixed(2)}</b>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                )}
                <div style={{ flex: 1 }}>
                  <div style={{ padding: "1mm 0 0 1mm" }}>Remarks</div>
                  <div style={{ padding: "1mm", fontSize: "3mm" }}>
                    {dimensionList.map((d) => {
                      return <p>{d}</p>;
                    })}
                  </div>
                </div>
              </div>
            </div>
            <div style={{ width: "4mm" }}>
              <p
                style={{
                  transform: "rotate(90deg)",
                  transformOrigin: "bottom left",
                  height: "4.5mm",
                  whiteSpace: "nowrap",
                  marginRight: "1mm",
                }}
              >
                <b>F-OP:01/REV00/1 12 16</b>
              </p>
            </div>
          </div>
        </div>
        <div style={{ height: "4mm", display: "flex", alignItems: "center" }} className="border-black">
          <div
            style={{
              backgroundColor: "#034da2",
              color: "#fff",
              height: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "3mm",
              padding: "0 1mm",
            }}
          >
            <p>
              <b>NON INSURED SHIPMENT</b>
            </p>
          </div>
          <div
            style={{
              backgroundColor: "#034da2",
              color: "#fff",
              height: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "3mm",
              padding: "0 1mm",
              borderLeft: "1px solid white",
            }}
          >
            <p>
              <b>NON NEGOTIABLE OWNER'S RISK</b>
            </p>
          </div>
          <p
            style={{
              flex: 1,
              textAlign: "center",
              color: "#034da2",
              fontSize: "3.5mm",
            }}
          >
            <b>Track this airway bill at airfield.co.in · Call us: 9227223131 · Transporter Id: 24AALCA0600L1Z0</b>
          </p>
        </div>
      </div>
      <hr style={{ marginTop: "6mm", marginBottom: "1mm", border: "none" }} />
      <div
        style={{
          width: "210mm",
          fontSize: "2mm",
          margin: "0 auto 1mm auto",
          lineHeight: "3mm",
          fontFamily: '"Saira Extra Condensed", serif',
        }}
      >
        <div style={{ textAlign: "center", paddingTop: "1mm" }}>
          <p style={{ fontSize: "4mm" }}>
            <b>AIRFIELD EXPRESS PVT. LTD.</b>
          </p>
          <p style={{ fontSize: "3mm", paddingTop: "0.5mm" }}>
            Regd. Office: Airfield Express Pvt. Ltd. 15/A, Ground Floor, Sant Nagar East of Kailash, New Delhi Pin 110065 Delhi India
            &nbsp;&nbsp;|&nbsp;&nbsp;Helpline no: 9227223131 &nbsp;&nbsp;|&nbsp;&nbsp;Mail: info@airfield.co.in
          </p>
          <p style={{ fontSize: "3mm", paddingTop: "0.5mm" }}>
            <u>TERMS AND CONDITIONS OF LOGISTICS CARRIAGE</u>
          </p>
          <p style={{ fontSize: "3mm", paddingTop: "0.5mm" }}>
            This Consignment is accepted by Airfield Express Pvt.Ltd. by its employees and agents referred to collectively herein after as
            "AIRFIELD EXPRESS" subject to the terms and conditions set out hereunder.
          </p>
        </div>
        <div className="multi-column" style={{ padding: "2.5mm 1mm 1mm 1mm" }}>
          {/* Previous content here */}
          <div className="section">
            <h3>1. CONSIGNORS OBLIGATION AND ACKNOWLEDGEMENT</h3>
            <div className="indent">
              <p>
                1.1 By tendering materials for Consignment via AIRFIELD EXPRESS, it is deemed that the consignor agrees to the terms and
                conditions stated herein.
              </p>
              <p>
                1.2 The consignor warrants that he is the owner or the authorised agent of the owner of the goods transported here under and
                that the consignor hereby accepts AIRFIELD EXPRESS terms and conditions for itself and/ or as and agent for and on behalf of
                any other person having any interest in the Consignment.
              </p>
              <p>
                1.3 The consignor warrants that each article in the Consignment is property described on this Airwaybill and it does not
                contravene the provisions of the Indian Post Office Act or any other law for the time being in force and has not been
                declared by AIRFIELD EXPRESS to be unacceptable for transport as specified under Section 11 below and that the Consignment
                is properly marked and addressed and packed to ensure safe handling.
              </p>
              <p>
                1.4 The consignor shall be solely liable for all costs and expenses (which shall without limitations include Octroi, state
                and local taxes and imports) related to the Consignments and for costs incurred either in returning the Consignment to the
                consignor or warehousing the Consignment pending such return.
              </p>
              <p>
                1.5 The consignor accepts the condition that the Consignment is being carried by AIRFIELD EXPRESS from point of rendering
                only upto the address shown on this Airwaybill and in case this Consignment has to be rerouted/redirected/returned for any
                reason whatsoever the consignor shall pay in advance all charges levied by AIRFIELD EXPRESS for such rerouting/redirection/
                return as per the normal schedule of AIRFIELD EXPRESS as also any Octroi. State Local Taxes imposes etc. applicable thereon,
                AIRFIELD EXPRESS will hold such Consignments at Destination mentioned on the Airwaybill for maximum period of 10 days from
                the date of Consignment. Thereafter AIRFIELD EXPRESS reserves the right to destroy the Consignment without informing the
                consignor and the consignor shall indemnify AIRFIELD EXPRESS against any claim or liability.
              </p>
              <p>
                1.6 Packing of the material rendered for the Consignment is the responsibility of the consignor including placement of such
                materials inside the containers supplied by AIRFIELD EXPRESS if any not withstanding anything else in these terms and
                conditions.
              </p>
            </div>
          </div>
          <div className="section">
            <h3>2. AIRFIELD EXPRESS RIGHT OF INSPECTION OF CONSIGNMENT</h3>
            <div className="indent">
              <p>2.1 AIRFIELD EXPRESS has the right but not the obligation to open and/or inspect the Consignment.</p>
              <p>
                2.2 AIRFIELD EXPRESS reserves the right to refuse Consignments not conforming to these terms and conditions without
                assigning any reason whatsoever.
              </p>
            </div>
          </div>
          <div className="section">
            <h3>3. THE AIRWAYBILL</h3>
            <div className="indent">
              <p>
                3.1 The AIRFIELD EXPRESS Airwaybill is non negotiable and the consignor acknowledges that it has been prepared by the
                consignor or by AIRFIELD EXPRESS on behalf of the Consignor.
              </p>
              <p>
                3.2 The responsibility of AIRFIELD EXPRESS for a Consignment accepted under a Airwaybill ceases when the consignee
                acknowledges the receipt of the Consignment by affixing his signature on the return to Origin copy and/or the delivery
                sheet.
              </p>
              <p>3.3 All Consignments under the Airwaybill are carried at Consignor’s risk.</p>
            </div>
          </div>
          <div className="section">
            <h3>4. INSURANCE</h3>
            <div className="indent">
              <p>
                4.1 While AIRFIELD EXPRESS has developed a sophisticated tracking system for all Consignments carried in its network and has
                experienced manpower to handle all Consignments, The consignor may if he so desires insure his Consignments at his own
                costs.
              </p>
            </div>
          </div>
          <div className="section">
            <h3>5. TAXES &amp; DUTIES</h3>
            <div className="indent">
              <p>
                5.1 Any Octroi, Sales Tax or Duties as may be applicable on this Consignment will be payable by the consignee at the time of
                delivery of the Consignment. AIRFIELD EXPRESS reserves the right of lien on any Consignment till all its duties are paid in
                full in respect of freight, octroi, taxes and other charges.
              </p>
            </div>
          </div>
          <div className="section">
            <h3>6. CHARGEABLE WEIGHT</h3>
            <div className="indent">
              <p>
                6.1 Every Consignment shall be charged by its chargeable weight as defined hereunder and not the actual weight. The
                chargeable weight shall be higher of (a) the actual weight rounded off to the next higher half kg or one kg as per the rate
                category agreed to or (b) The volume weight similarly rounded off as in (a) above.
              </p>
              <p>
                6.2 Volume weight of the Consignment in kilograms is its gross cubic volume in cubic centimeters i.e. Length x Width x
                Height divided by 5000.
              </p>
            </div>
          </div>
          <div className="section">
            <h3>7. LIEN ON GOODS SHIPPED</h3>
            <div className="indent">
              <p>
                7.1 AIRFIELD EXPRESS will have a lien on goods shipped for all freight charges. Octroi, Customs, State and Local Taxes,
                advance or other charges of any kind arising out of transportation and warehousing services hereunder may refuse to
                surrender possession of goods until such charges are paid.
              </p>
              <p>
                7.2 Further, if such charges are not paid to AIRFIELD EXPRESS within 10 days, then AIRFIELD EXPRESS may store the goods at
                the defaulting consignor’s/ consignee’s own risk.
              </p>
              <p>
                7.3 AIRFIELD EXPRESS reserves its right to sell the goods by public auction, tender, private agreement or otherwise or even
                destory the goods without prejudice to AIRFIELD EXPRESS’s other legal remedies to recover its cost charges and expenses if
                the charges as indicated aforesaid are not paid by the consignor/consignee within 10 days except for restricted/Banned items
                of goods as indicated in Section 11 herein under.
              </p>
              <p>
                7.4 AIRFIELD EXPRESS reserves rights to entrust the goods to any other carrier.Airfield Express will not be liable for any
                delay,damage or loss during its transit through other carrier of situtation beyond our control i.e occured due to acts of
                god or man-made clamities.
              </p>
              <p>
                7.5 No complaint/claim shall be entartained by Airfield Express after the expiry of 15 days from the date of booking of
                shipment.
              </p>
            </div>
          </div>
          <div className="section">
            <h3>8. RESTRICTED LIABILITY</h3>
            <div className="indent">
              <p>
                8.1 Without prejudice to section 9 and section 10 the liability of AIRFIELD EXPRESS for any loss or damage to the
                Consignment (which terms shall include all documents or parcels consigned through AIRFIELD EXPRESS) shall be lowest of (a)
                Rs. 2,500/- or (b) The amount of loss or damage to the document or parcel actually sustained or (c) The actual value of the
                document or parcel as determined without regards to the commercial utility or special value to the consignor.
              </p>
              <p>
                (i) The actual value of the document or parcel shall be ascertained by reference to the cost of preparation or replacement/
                reconstruction value at the time and place of Consignment but under no circumstances shall exceed Rs. 2,500/-
              </p>
              <p>
                (ii) The actual value of a parcel (which term shall include any item of commercial value which is transported hereunder)
                shall be ascertained by reference to its cost by repair or replacement/resale or fair market value not exceeding the
                original cost of the article actually paid by the consignor subject to and within overall limit of Rs. 2,500/-
              </p>
              <p>
                (iii) In the event of any loss or damage to Consignments, which are insured by the consignor, Airfield Express Pvt. Ltd.,
                may at the request of the consignor, issue Loss/damage/shortage Certificate with the sole purpose of enabling the consignor
                to lodge insurance claim with its Insurance Company. The Consignor agrees and acknowledges that the Loss/shortage/damage
                Certificate will be issued by Airfield Express without admission of any claim, and that Airfield Express shall be discharged
                of all liabilities, if any, arising out of the Consignment on acceptace of the Loss/damage/shortage Certificate by the
                Shipper.
              </p>
            </div>
          </div>
          <div className="section">
            <h3>9. CONSEQUENTIAL DAMAGES EXCLUDED</h3>
            <div className="indent">
              <p>
                9.1 AIRFIELD EXPRESSS SHALL NOT BE LIABLE IN ANY EVENT FOR ANY CONSEQUENTIAL OR SPECIAL DAMAGES OR OTHER DIRECT OR INDIRECT
                LOSS HOWSOEVER ARISING whether or not Airfield Express has knowledge that such damages might be incured including but not
                limited to loss of income, profits, interest, utility or loss of market.
              </p>
            </div>
          </div>
          <div className="section">
            <h3>10. LIABILITIES NOT ASSUMED</h3>
            <div className="indent">
              <p>
                10.1 In particular Airfield Express will not be liable for any loss or damage to the Consignment or a delay in picking up or
                delivering Consignment if it is:
              </p>
              <p>
                a. Due to acts of God force majeure occurrence of any cause reasonably beyond the control of Airfield Express or loss or
                damage caused through strikes, riots, political and other disturbances such as fire, accident of the vehicle carrying the
                goods, explosions, beyond the control of Airfield Express for the goods that are carried by Airfield Express.
              </p>
              <p>b. Caused by:</p>
              <p>
                (i) The act fault or commission of the consignor the consignee or any other party claiming an interest in the Consignment
                (including violation of any terms or conditions thereof) or any other person.
              </p>
              <p>(ii) Carriers such as Airlines /Airways &amp; Road Transport not adhering to schedule for any reason whatsoever.</p>
              <p>(iii) Government officials in discharge of their official duties such as Customs/ Taxation/Octroi inspection etc.</p>
              <p>(iv) The nature of the Consignment or any defects characteristics inherent vice thereof.</p>
              <p>(v) Electrical or magnetic injury erasure of other such damages to Photographic images or recording in any form.</p>
              <p>
                10.2 The consignor indemnifies Aifield Express against loss, damages, penalties, actions proceedings etc. that may be
                instituted by any Government Officials in discharge of their official duties such as Customs/ Taxation/Octroi inspection
                etc.
              </p>
              <p>
                10.3 Notwithstanding what is stated above whilst Airfield Express will endeavour to exercise its best efforts to provide
                expeditious delivery in accordance with its regular delivery. Airfield Express WILL NOT UNDER ANY CIRCUMSTANCES BE LIABLE
                FOR DELAY IN PICK UP TRANSPORTATION OR DELIVERY OF ANY CONSIGNMENT REGARDLESS OF CAUSE OF SUCH DELAYS.
              </p>
              <p>
                10.4 No liability is assumed for any errors and/or omissions in any information/ data which is imparted in respect of the
                Consignment travelling under the Air Airwaybill.
              </p>
            </div>
          </div>
          <div className="section">
            <h3>11. MATERIALS NOT ACCEPTED FOR CARRIAGE</h3>
            <div className="indent">
              <p>
                11.1 “Except as per written agreement, between consignor and Airfield Express. Airfield Express will not carry materials.”
              </p>
              <p>a. Not permitted by the laws/rules/restrictions in force and</p>
              <p>
                b. Any items notified by Airfield Express to be Restricted/Banned/Dangerous/Prohibited item, including share certificates
                and blank signed share transfer forms. Airfield Express shall not be liable for any such Consignment which is booked
                undeclared and the consignor shall keep Airfield Express indemnified against all claims, charges and expenses incurred by
                Airfield Express due to such Restricted/Banned/Dangerous/Prohibited items entering into the network of Airfield Express
                through the Consignor
              </p>
              <p>11.2 A detailed list of materials not accepted for carriage is available on request.</p>
            </div>
          </div>
          <div className="section">
            <h3>12. CLAIMS</h3>
            <div className="indent">
              <p>
                12.1 Any claim must be brought by the consignor and delivered in writing to the office of Airfield Express nearest to the
                location at which the Consignment is accepted within 30 days of the date of such acceptance. No claim can be made against
                Airfield Express beyond this time limit.
              </p>
              <p>
                12.2 No claim for loss or damage will be entertained until all charges have been paid. The amount of any such claim will not
                be deducted from any transportation charges owned to Airfield Express.
              </p>
            </div>
          </div>
          <div className="section">
            <h3>13. COPY DETAIL</h3>
            <div className="indent">
              <p>13.1 Blue for consignor, Pink copy for Org Off copy, Orange copy for Consignee.</p>
            </div>
          </div>
          <p>NOTE: ALL DISPUTES AND CLAIMS ARE SUBJECT TO NEW DELHI JURISDICTION.</p>
        </div>
      </div>
    </>
  );
};

export default AwbSlip;
